export function removeMarkdownFormatting(markdownText) {
  // 去除标题符号 #
  let plainText = markdownText.replace(/^#+\s+/gm, "");
  // 去除列表符号 - 和 *
  plainText = plainText.replace(/^[\*\-]\s+/gm, "");
  // 去除行内代码符号 `
  plainText = plainText.replace(/`([^`]+)`/g, "$1");
  // 去除加粗和斜体符号 ** 和 *
  plainText = plainText.replace(/\*\*([^*]+)\*\*/g, "$1");
  plainText = plainText.replace(/\*([^*]+)\*/g, "$1");
  // 去除链接格式 [text](url)
  plainText = plainText.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
  // 去除图片格式 ![alt](url)
  plainText = plainText.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");
  // 去除引用符号 >
  plainText = plainText.replace(/^>\s+/gm, "");
  // 去除水平线 ---
  plainText = plainText.replace(/^---+/gm, "");
  // 去除其他 Markdown 符号
  plainText = plainText.replace(/[_~`]/g, "");
  // 去除换行符
  plainText = plainText.replace(/\n/g, "");

  return plainText;
}
